import { scoreDecompositionCharts } from 'utils/charts/constants';

export const getActiveBarCountAndHighestScore = (rmData) =>
    rmData &&
    scoreDecompositionCharts.reduce(
        (acc, config) => {
            const score = rmData[config.score];

            if (score <= 0) return acc;

            return {
                ...acc,
                highestScore:
                    score > acc.highestScore ? score : acc.highestScore,
                activeBarCount: acc.activeBarCount + 1
            };
        },
        { highestScore: 0, activeBarCount: 0 }
    );

export const generateGraphicForCorrelation = ({
    config,
    startPointValue,
    index,
    rmData,
    left
}) => {
    return [
        {
            type: 'text',
            style: {
                text: config.displayValue,
                fontFamily: 'Outfit',
                fontSize: 10,
                fontWeight: 600,
                fill: '#929292'
            },
            cursor: 'default',
            top: startPointValue + index * 54 + 6,
            left: `${left}px`
        },
        {
            type: 'text',
            style: {
                text: 'Risk Score',
                fontFamily: 'Outfit',
                fontSize: 10,
                fontWeight: 400,
                fill: '#929292'
            },
            cursor: 'default',
            top: startPointValue + index * 54 + 18,
            left: `${left}px`
        },
        {
            type: 'text',
            style: {
                text: rmData[config.score],
                fontFamily: 'Outfit',
                fontSize: 10,
                fontWeight: 600,
                fill: '#000000'
            },
            cursor: 'default',
            top: startPointValue + index * 54 + 18,
            left: `${left + 50}px`
        }
    ];
};

export const generateGraphicsForScenario = ({
    config,
    startPointValue,
    index,
    rmData,
    left
}) => {
    return [
        {
            type: 'text',
            style: {
                text: config.displayValue,
                fontFamily: 'Outfit',
                fontSize: 10,
                fontWeight: 600,
                fill: '#929292'
            },
            cursor: 'default',
            top: startPointValue + index * 54,
            left: `${left}px`
        },
        {
            type: 'text',
            style: {
                text: 'Rank',
                fontFamily: 'Outfit',
                fontSize: 10,
                fontWeight: 400,
                fill: '#929292'
            },
            cursor: 'default',
            top: startPointValue + index * 54 + 12,
            left: `${left}px`
        },
        {
            type: 'text',
            style: {
                text: rmData[config.rank],
                fontFamily: 'Outfit',
                fontSize: 10,
                fontWeight: 600,
                fill: '#000000'
            },
            cursor: 'default',
            top: startPointValue + index * 54 + 12,
            left: `${left + 35}px`
        },
        {
            type: 'text',
            style: {
                text: 'Risk Score',
                fontFamily: 'Outfit',
                fontSize: 10,
                fontWeight: 400,
                fill: '#929292'
            },
            cursor: 'default',
            top: startPointValue + index * 54 + 24,
            left: `${left}px`
        },
        {
            type: 'text',
            style: {
                text: rmData[config.score],
                fontFamily: 'Outfit',
                fontSize: 10,
                fontWeight: 600,
                fill: '#000000'
            },
            cursor: 'default',
            top: startPointValue + index * 54 + 24,
            left: `${left + 50}px`
        }
    ];
};
